module.exports = __webpack_public_path__ + "img/logo_smarti.6f08e669.png";